import React, { useRef } from "react";
import ControlCameraIcon from "@material-ui/icons/ControlCamera";
import { useDrag } from "react-dnd";

const Actioncard = (props) => {
  const noref=useRef("")
  const [{ isDragging }, drag] = useDrag({
    type:
      props.category == "App" && !props.node_data.isInstalled
        ? "notaction_card"
        : "action_card",
    item:
      props.category == "App"
        ? {
            id: props.node_data.id,
            category: props.category,
            type: props.node_data.type,
            name: props.node_data.name,
          }
        : {
            id: props.node_data.id,
            category: props.category,
            type: props.node_data.type,
            name: props.node_data.name,
          },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  });

  return (
    <div
      ref={props.category == "App" && !props.node_data.isInstalled ?noref:drag}
      opacity={isDragging ? "0.5" : "1"}
      style={{
        position: "relative",
        backgroundColor: "white",
        color: "#2C40CE",
        boxShadow: "0px 0px 10px #D9D9D9",
        width: 250,
        borderRadius: 10,
        padding: 13,
        opacity:
          props.category == "App" && !props.node_data.isInstalled ? "0.4" : "1",
      }}
    >
      <span style={{ color: "#2C40CE", display: "flex" }}>
        {props.category == "App" ? props.node_data.name : props.node_data.name}
      </span>
      <span
        style={{ position: "absolute", color: "#2C40CE", right: 10, top: 10 }}
      >
        <ControlCameraIcon />
      </span>
    </div>
  );
};

export default Actioncard;
